import React, { useEffect, useState } from "react";
import useStyles from "../../style";
import { renderErrorCreatePool } from "../../../../utils/validate";
import { Controller } from "react-hook-form";

import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import Chip from "@material-ui/core/Chip";
import {
  TextField,
  ListItemText,
  Checkbox,
  MenuItem,
  makeStyles,
} from "@material-ui/core";
import { getForbiddenCountries } from "../../../../request/config";
import { IS_PERMANENT_FORBIDDEN_COUNTRIES_ENABLED } from "../../../../constants";

const countries = require("./countries.json");

function ForbiddenCountry(props: any) {
  const classes = useStyles();
  const {
    register,
    setValue,
    errors,
    watch,
    getValues,
    needValidate,
    poolDetail,
    control,
  } = props;
  const renderError = renderErrorCreatePool;

  const [permanantForbiddenCountries, setPermanantForbiddenCountries] = useState<any>([]);

  const normalizeCountries = (list: any[]) => {
    return (list || []).map((c) =>
      typeof c === "string" ? c : c.code ? c.code : c.country
    );
  };

  const getForbiddenCountriesList = async () => {
    try {
      const response = await getForbiddenCountries();
      const hard = response.data.find(
        (item: any) => item.name === "Hard-Restricted-Countries"
      );
      setPermanantForbiddenCountries(normalizeCountries(hard?.value || []));
    } catch (error) {
      console.error("Error fetching countries", error);
    }
  };

  useEffect(() => {
    getForbiddenCountriesList();
  }, []);

  useEffect(() => {
    if (poolDetail?.forbidden_countries) {
      const initial = poolDetail.forbidden_countries || [];
      const merged = Array.from(
        new Set([...initial, ...permanantForbiddenCountries])
      );
      setValue("forbidden_countries", merged);
      // setValue("forbidden_countries", poolDetail?.forbidden_countries || []);
    }
  }, [poolDetail, setValue]);




  return (
    <>
      <div>
        <label className={classes.exchangeRateTitle}>Forbidden Countries</label>
      </div>

      <div className={classes.formControl}>
        <label className={classes.formControlLabel}>Forbidden Countries</label>
        <Controller
          control={control}
          name="forbidden_countries"
          defaultValue={
            poolDetail?.forbidden_countries || [
              "CAN", "USA", "CHN", "MMR", "HKG", "IRN", "IRQ", "SDN", "SYR"
            ]
          }
          render={({ onChange, value }) => {
            // Ensure permanent countries are always included
            const finalValue = Array.from(
              new Set([...(value || []), ...permanantForbiddenCountries])
            );

            const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
              const selected = event.target.value as string[];

              // Filter out permanent countries so they can't be removed
              const nonPermanent = selected.filter(
                (v) => !permanantForbiddenCountries.includes(v)
              );

              // Always re-add permanent ones
              const nextValue = [...nonPermanent, ...permanantForbiddenCountries];
       
              onChange(nextValue);
            };

            return (
              <Select
                label="Countries"
                className={classes.formControlInput}
                multiple
                value={finalValue}
                onChange={handleChange}
                input={<Input id="select-multiple-chip" />}
                renderValue={(selected: any) => (
                  <div>
                    {selected?.map((val: any) => (
                      <Chip
                        key={val}
                        label={val}
                        disabled={IS_PERMANENT_FORBIDDEN_COUNTRIES_ENABLED &&
                          permanantForbiddenCountries.includes(val)}
                        style={{ marginRight: ".5rem" }}
                      />
                    ))}
                  </div>
                )}
              >
                {countries.map((country: any) => {
                  const isPermanent =
                    IS_PERMANENT_FORBIDDEN_COUNTRIES_ENABLED &&
                    permanantForbiddenCountries.includes(country.code);

                  return (
                    <MenuItem
                      key={country.code}
                      value={country.code}
                      disabled={isPermanent}
                    >
                      <Checkbox
                        checked={finalValue.includes(country.code)}
                        disabled={isPermanent}
                      />
                      <ListItemText primary={country.name} />
                    </MenuItem>
                  );
                })}
              </Select>
            );
          }}
        />

        <p className={classes.formErrorMessage}>
          {renderError(errors, "forbidden_countries")}
        </p>
      </div>
    </>
  );
}

export default ForbiddenCountry;
